import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

// Pages
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import OrderHistory from "./pages/OrderHistory";
import GlamAdvisor from "./pages/GlamAdvisor";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";

// Google Analytics 4 - Tracks page views automatically on route changes
import GoogleAnalyticsTracker from "./components/GoogleAnalyticsTracker";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          {/* Google Analytics 4 Page View Tracker - Must be inside BrowserRouter */}
          <GoogleAnalyticsTracker />
          
          <div className="min-h-screen flex flex-col bg-[#FAFAF9]">
            <Toaster 
              position="top-right" 
              toastOptions={{
                style: {
                  fontFamily: "'Outfit', sans-serif",
                  borderRadius: '1rem',
                },
              }}
            />
            <Routes>
              {/* Admin Routes - No Header/Footer */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/*" 
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                } 
              />
              
              {/* GlamAdvisor 3D Route - No Header/Footer (Immersive Experience) */}
              <Route path="/glam-advisor" element={<GlamAdvisor />} />
              
              {/* Public Routes with Header/Footer */}
              <Route path="*" element={
                <>
                  <Header />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/shop" element={<Shop />} />
                      <Route path="/product/:id" element={<ProductDetail />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />
                      <Route path="/reset-password" element={<ResetPassword />} />
                      <Route 
                        path="/cart" 
                        element={
                          <ProtectedRoute>
                            <Cart />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/wishlist" 
                        element={
                          <ProtectedRoute>
                            <Wishlist />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/checkout/success" 
                        element={
                          <ProtectedRoute>
                            <CheckoutSuccess />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/checkout/cancel" 
                        element={
                          <ProtectedRoute>
                            <CheckoutCancel />
                          </ProtectedRoute>
                        } 
                      />
                      <Route 
                        path="/orders" 
                        element={
                          <ProtectedRoute>
                            <OrderHistory />
                          </ProtectedRoute>
                        } 
                      />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
